import { CustomTabPanel } from "@/erp/sale";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { a11yProps, sizeTab } from "@/shared";
import { useState } from "react";
import NapsRed from "../components/CoberturaNaps";


export default function CoberturaNapsPage() {
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Cobertura Naps"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Cobertura NAPS'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <NapsRed />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}
